// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".564.0.0." + {2239: "29f222963c2f2d01",2733: "1d2e1748f111be3e",2944: "1ce23c42bb6faa91",5233: "6b154404e764dd29",5338: "2d45ad003ddf356f",8756: "140895df4c825a18",9289: "4922c220de895eb6",}[chunkId] + ".css"
}